<template>
    <div class="fluid">
        <h1 class="app-title">Migração e Edição de EF</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard ref="wizard" nextButtonText="Próximo" backButtonText="Anterior" finishButtonText="Concluir"
                        title subtitle color="#004262">
                        <wizard-step slot-scope="props" slot="step" :tab="props.tab" :index="props.index"></wizard-step>
                        <tab-content icon="fa fa-search" class="mx-auto">

                        </tab-content>
                        <tab-content icon="fa fa-file-text-o" class="mx-auto" title="Resultado da Pesquisa">
                            <b-card>
                                <!-- TODO TABLE CDA -->
                                <b-row class="d-flex justify-content-between">
                                    <b-col>
                                        <label class="mt-3">Processo: <strong>{{ processo.numeroUnico }}</strong> / CDAS:
                                            <strong>{{ processo.cdas.length }}</strong> / Devedores:
                                            <strong>{{ processo.quantidadeDevedores }}</strong></label>
                                    </b-col>
                                </b-row>
                                <b-table id="tableCda" ref="tableCda" :items="processo.cdas" :fields="fieldsCda" striped
                                    small responsive :busy="false" show-empty style="max-height: 200px" hover bordered
                                    sort-icon-left class="mb-0" head-variant="light">
                                    <div slot="table-busy" class="text-center text-primary my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> Carregando...</strong>
                                    </div>
                                    <template slot="empty">
                                        <p class="my-auto">Nenhuma CDA encontrada.</p>
                                    </template>

                                    <template slot="HEAD_selecionar">
                                        <b-form-checkbox v-model="configTableCda.checkedAll"
                                            class="justify-content-center text-center" @change="toggleAllCdas" />
                                    </template>
                                    <template slot="selecionar" slot-scope="row">
                                        <b-form-checkbox class="mx-auto justify-content-center text-center"
                                            :checked="selectedsCdas.includes(row.item)"
                                            @change="toggleCheckCda($event, row.item)" />
                                    </template>
                                </b-table>

                                <b-row md="12" class="mb-3 mt-3">
                                    <b-col sm="12" md="12">
                                        <b-button variant="primary" @click="abrirModalCdaModoInclusao()">
                                            <i class="fa fa-plus" style="margin-right: 5px;"></i> Incluir CDA
                                        </b-button>
                                        <b-button :disabled="selectedsCdas.length == 0" variant="primary"
                                            style="margin-left: 10px;" @click="excluirCdas()">
                                            <i class="fa fa-times" style="margin-right: 5px;"></i> Excluir CDA
                                        </b-button>
                                        <b-button :disabled="selectedsCdas.length != 1" v-b-modal.modal-incluir-editar-cda
                                            variant="primary" @click="abrirModalCdaModoEdicao()" style="margin-left: 10px;">
                                            <i class="fa fa-pencil" style="margin-right: 5px;"></i>Editar
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <!-- TODO TABLE DEVEDOR -->
                                <b-table id="tableDevedor" ref="tableDevedor" :items="processo.devedores"
                                    :fields="fieldsDevedor" style="max-height: 200px" striped small responsive :busy="false"
                                    show-empty hover bordered sort-icon-left class="mb-0" head-variant="light">
                                    <div slot="table-busy" class="text-center text-primary my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> Carregando...</strong>
                                    </div>
                                    <template slot="empty">
                                        <p class="my-auto">Nenhum Devedor encontrado.</p>
                                    </template>

                                    <template slot="HEAD_selecionar">
                                        <b-form-checkbox v-model="configTableDevedor.checkedAll"
                                            class="justify-content-center text-center" @change="toggleAllDevedores" />
                                    </template>
                                    <template slot="selecionar" slot-scope="row">
                                        <b-form-checkbox class="mx-auto justify-content-center text-center"
                                            :checked="selectedsDevedores.includes(row.item)"
                                            @change="toggleCheckDevedor($event, row.item)" />
                                    </template>
                                </b-table>

                                <b-row md="12" class="mb-3 mt-3">
                                    <b-col sm="12" md="12">
                                        <b-button variant="primary" @click="abrirModalDevedorModoInclusao()">
                                            <i class="fa fa-plus" style="margin-right: 5px;"></i> Incluir Devedor
                                        </b-button>
                                        <b-button :disabled="selectedsDevedores.length == 0" variant="primary"
                                            style="margin-left: 10px;" @click="excluirDevedor()">
                                            <i class="fa fa-times" style="margin-right: 5px;"></i> Excluir Devedor
                                        </b-button>
                                        <b-button :disabled="selectedsDevedores.length != 1" v-b-modal.modal-editar-devedor
                                            variant="primary" @click="abrirModalDevedorModoEdicao()"
                                            style="margin-left: 10px;">
                                            <i class="fa fa-pencil" style="margin-right: 5px;"></i>Editar
                                        </b-button>
                                    </b-col>
                                </b-row>

                                <b-row md="12" class="mb-3 mt-3">
                                    <b-col>
                                        <label class="mt-3">Data de Ajuizamento: <strong>{{ processo.dataajuizamento === ''
                                            ?
                                            'Não possui.' : processo.dataajuizamento
                                        }}</strong></label><br>
                                        <b-button v-b-modal.modal-editar-data-ajuizamento variant="primary"
                                            @click="abrirModalDataAjuizamentoEdicao()">
                                            <i class="fa fa-pencil"></i> Editar Data de Ajuizamento
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </tab-content>

                        <template slot="footer" class="pb-0">
                            <hr class="mt-0 mb-2" />
                            <div class="row justify-content-center">
                                <div class="d-flex justify-content-between mb-3">
                                    <b-button id="btnVoltar" @click="voltar" variant="primary">
                                        Voltar
                                    </b-button>
                                </div>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>

        <!-- TODO MODAL CDA -->
        <b-modal ref="modal-incluir-editar-cda" id="modal-incluir-editar-cda" size="xl"
            :content-class="'shadow ' + getTheme" :title="'Incluir/Editar CDA'" header-bg-variant="info"
            header-text-variant="white">
            <b-card no-gutters>
                <b-row class="mt-1">
                    <b-col sm="12" md="12">
                        <b-form-group label="Número da Dívida Ativa:*" label-for="numeroDivida"
                            :class="'text-label ' + (!cdaModalValidations.numeroDivida.valid ? 'is-invalid' : '')">
                            <b-form-input type="text" id="numeroDivida" v-model="cdaModal.numeroDivida"
                                v-mask="['#########']" @input="alterarModalCdaParaModoInclusao()"
                                :class="'text-label required ' + (!cdaModalValidations.numeroDivida.valid ? 'is-invalid' : '')" />
                            <div v-if="!exibirMensagemIntitutoAguaETerra.valid" class="invalid-message">
                                {{ exibirMensagemIntitutoAguaETerra.message }}
                            </div>
                            <div v-if="!cdaModalValidations.numeroDivida.valid" class="invalid-message">
                                {{ cdaModalValidations.numeroDivida.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col sm="12" md="12">
                        <b-form-group label="Tipo do Crédito:*" label-for="tipoCredito" class="text-label">
                            <b-form-input type="text" id="tipoCredito" v-model="cdaModal.tipoCredito" class="text-label"
                                :disabled="true" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col sm="12" md="12">
                        <b-form-group label="Origem do Crédito:*" label-for="origem" class="text-label">
                            <b-form-input type="text" id="origem" v-model="cdaModal.origem" class="text-label"
                                :disabled="true" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-incluir-editar-cda')" style="color: white !important;">
                    <i class="fa fa-arrow-left"></i>
                    Cancelar
                </b-button>
                <b-button v-if="modalCdaModoIncluir" variant="primary" @click="consultarCda()">
                    Consulta
                </b-button>
                <b-button v-if="!modalCdaModoIncluir" variant="primary" @click="adicionarCda()">
                    <i class="fa fa-save"></i>
                    Salvar
                </b-button>
            </template>
        </b-modal>

        <!-- TODO MODAL DATA AJUIZAMENTO -->
        <b-modal ref="modal-editar-data-ajuizamento" id="modal-editar-data-ajuizamento" size="xl"
            :content-class="'shadow ' + getTheme" :title="'Editar Data de Ajuizamento'" header-bg-variant="info"
            header-text-variant="white">
            <b-card no-gutters>
                <b-row class="mt-1">
                    <b-col sm="12" md="12">
                        <b-form-group label="Data de Ajuizamento:*" label-for="data-ajuizamento" class="text-label">
                            <b-form-input type="text" id="data-ajuizamento" v-model="formDataEdicao.dataAjuizamento"
                                v-mask="['##/##/####']" class="text-label required" />
                            <div v-if="!dataAjuizamentoValidation.campoObrigatorio.valid" class="invalid-message">
                                {{ dataAjuizamentoValidation.campoObrigatorio.message }}
                            </div>
                            <div v-if="!dataAjuizamentoValidation.formatoCorreto.valid" class="invalid-message">
                                {{ dataAjuizamentoValidation.formatoCorreto.message }}
                            </div>
                            <div v-if="!dataAjuizamentoValidation.anoValido.valid" class="invalid-message">
                                {{ dataAjuizamentoValidation.anoValido.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-editar-data-ajuizamento')"
                    style="color: white !important;">
                    <i class="fa fa-arrow-left"></i>
                    Cancelar
                </b-button>
                <b-button variant="primary" :disabled="!dataAjuizamentoValidation.campoObrigatorio.valid
                    || !dataAjuizamentoValidation.formatoCorreto.valid
                    || dataAjuizamentoOriginal === formDataEdicao.dataAjuizamento
                    || !dataAjuizamentoValidation.anoValido.valid" @click="editarDataAjuizamento()">
                    <i class="fa fa-save"></i>
                    Salvar
                </b-button>
            </template>
        </b-modal>

        <!-- TODO MODAL DEVEDOR -->
        <b-modal ref="modal-incluir-editar-devedor" id="modal-incluir-editar-devedor" size="xl"
            :content-class="'shadow ' + getTheme" :title="'Incluir/Editar Devedor'" header-bg-variant="info"
            header-text-variant="white">
            <b-card no-gutters>
                <b-row class="mt-1">
                    <b-col sm="12" md="12">
                        <b-form-group label="Nome:*" label-for="nome"
                            :class="'text-label ' + (!devedorModalValidations.nome.valid ? 'is-invalid' : '')">
                            <b-form-input type="text" id="nome" v-model="devedorModal.nome"
                                @input="alterarModalDevedorParaModoInclusao()"
                                :class="'text-label required ' + (!devedorModalValidations.nome.valid ? 'is-invalid' : '')" />
                            <div v-if="!devedorModalValidations.nome.valid" class="invalid-message">
                                {{ devedorModalValidations.nome.message }}
                            </div>
                            <div v-if="!devedorModalValidations.nome.valid" class="invalid-message">
                                {{ devedorModalValidations.nome.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <b-col sm="12" md="12">
                        <b-form-group label="CPF / CNPJ:*" label-for="cpfCnpj" class="text-label">
                            <b-form-input type="text" id="cpfCnpj" v-model="devedorModal.cpfCnpj"
                                v-mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']"
                                @input="alterarModalDevedorParaModoInclusao()"
                                :class="'text-label required ' + (!devedorModalValidations.cpfCnpj.valid ? 'is-invalid' : '')" />
                            <div v-if="!devedorModalValidations.cpfCnpj.valid" class="invalid-message">
                                {{ devedorModalValidations.cpfCnpj.message }}
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" style="color: white !important;"
                    @click="hide('modal-incluir-editar-devedor')">
                    <i class="fa fa-arrow-left"></i>
                    Cancelar
                </b-button>
                <b-button
                    :disabled="((devedorModal.cpfCnpj == null || devedorModal.cpfCnpj == '' || devedorModal.nome == null || devedorModal.nome == '') && modalDevedorModoIncluir == true)"
                    variant="primary" @click="salvarDevedor()">
                    <i class="fa fa-save"></i>
                    Salvar
                </b-button>
            </template>
        </b-modal>

        <b-modal ref="modal-incluir-dados-devedor" id="modal-incluir-dados-devedor" size="xl"
            :title="'Atualizar Cadastro do Devedor'" header-bg-variant="info" header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group label="CPF / CNPJ:" label-for="cpf" class="text-label required">
                                    <b-form-input type="text" id="num-documento" data-vv-as="CPF"
                                        v-model="contribuinte.documento" v-mask="['XXX.XXX.XXX-xx', 'XX.XXX.XXX/XXXX-##']"
                                        description="Somente os números" :disabled="true"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2" md="5">
                                <b-form-group label="Nome:" label-for="nome" class="text-label required">
                                    <b-form-input v-model="contribuinte.nome" type="text" id="nome" maxlength="100"
                                        @keyup="contribuinte.nome = removeSpecialCharacters(contribuinte.nome)"
                                        class="text-label required" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card title="Endereço">
                        <b-row>
                            <b-col sm="2" md="3">
                                <b-form-group label="CEP:" label-for="cep" class="text-label">
                                    <b-form-input type="text" id="cep" data-vv-as="cep" v-model="contribuinte.cep"
                                        v-mask="['#####-###']" description="Somente os números"
                                        @change="obterEnderecoPorCep()"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="2" md="5">
                                <b-form-group label="Logradouro:" label-for="logradouro" class="text-label">
                                    <b-form-input v-model="contribuinte.logradouro" type="text" id="logradouro"
                                        maxlength="100"
                                        @keyup="contribuinte.logradouro = removeSpecialCharactersGeral(contribuinte.logradouro)" />
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="2">
                                <b-form-group label="Número:" label-for="numero" class="text-label">
                                    <b-form-input v-model="contribuinte.numero" type="text" id="numero" maxlength="100"
                                        @keyup="contribuinte.numero = removeSpecialCharactersNumero(contribuinte.numero)" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group label="Complemento:" label-for="complemento" class="text-label">
                                    <b-form-input v-model="contribuinte.complemento" type="text" id="complemento"
                                        maxlength="30"
                                        @keyup="contribuinte.complemento = removeSpecialCharactersGeral(contribuinte.complemento)" />
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-form-group label="Bairro:" label-for="bairro" class="text-label">
                                    <b-form-input v-model="contribuinte.bairro" type="text" id="bairro" maxlength="50"
                                        @keyup="contribuinte.bairro = removeSpecialCharactersGeral(contribuinte.bairro)" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-1 mb-0">
                            <b-col sm="12" md="3">
                                <b-form-group label="UF:" label-for="uf" class="text-label">
                                    <multiselect class="multiselect-simple" name="uf" v-model="contribuinte.uf"
                                        :show-labels="false" :options="dados.ufs" :multiple="false" :close-on-select="true"
                                        :clear-on-select="true" :preserve-search="false" placeholder="Selecione"
                                        track-by="nome" label="nome" @input="listarMunicipios()">
                                        <template v-slot:first>
                                            <option :value="null">Selecionar</option>
                                        </template>
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-form-group label="Município:" label-for="municipio" class="text-label">
                                    <multiselect class="multiselect-simple" name="municipio"
                                        v-model="contribuinte.municipio" :show-labels="false" :options="dados.municipios"
                                        :multiple="false" :close-on-select="true" :clear-on-select="true"
                                        :preserve-search="false" placeholder="Selecione" track-by="codMunicipio"
                                        label="nome">
                                    </multiselect>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card title="Contato">
                        <b-row>
                            <b-col sm="12" md="3">
                                <b-form-group label="Telefone/Celular:" label-for="telefone" class="text-label">
                                    <b-form-input type="text" id="telefone" data-vv-as="telefone"
                                        v-model="contribuinte.telefone" v-mask="['(##) #####-####', '(##) ####-####']"
                                        description="Somente os números"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="3">
                                <b-form-group label="E-mail principal:" label-for="email" class="text-label">
                                    <b-form-input v-model="contribuinte.email" type="text" id="email" maxlength="100"
                                        ref="email"
                                        @keyup="contribuinte.email = removeSpecialCharactersGeral(contribuinte.email)" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-primary" @click="closeModal()">
                    <i class="fa fa-times"></i>
                    Cancelar
                </b-button>
                <b-button :disabled="(contribuinte.nome == null || contribuinte.nome.toString().trim() == '')"
                    variant="outline-primary" @click="salvarDadosDevedor()">
                    <i class="fa fa-times"></i>
                    Salvar
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { FormWizard, TabContent, WizardStep } from 'vue-form-wizard';

import axios from 'axios';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import formatarMixins from '../../mixins/formatarMixins';
import validacoesUtil from '../../util/validacoesUtil';
export default {
    components: {
        FormWizard,
        TabContent,
        WizardStep
    },
    mixins: [formatarMixins],
    data() {
        return {
            urlApi: null,
            token: null,
            formDataEdicao: {
                dataAjuizamento: ''
            },
            dataAjuizamentoOriginal: '',
            processo: {
                numeroUnico: null,
                dataajuizamento: '',
                quantidadeDevedores: null,
                cdas: [],
                devedores: []
            },
            selectedsCdas: [],
            cdaModal: {
                codCdaSefa: null,
                numeroUnico: null,
                codCdaAjuizamento: null,
                numeroDivida: null,
                tipoCredito: null,
                origem: null
            },
            configTableCda: {
                perPage: 10,
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0,
                quantidadeGeral: 0,
                totalProcessos: 0,
                visible: false
            },
            fieldsCda: [
                {
                    key: 'selecionar',
                },
                {
                    key: 'numeroDivida',
                    label: "CDA\'s"
                },
                {
                    key: 'tipoCredito',
                    label: 'Tipo de crédito'
                },
                {
                    key: 'origem',
                    label: 'Origem do crédito'
                }
            ],
            cdaValidations: {
                numeroDivida: { valid: true, message: "" }
            },
            cdaModalValidations: {
                numeroDivida: { valid: true, message: "" }
            },
            fieldsDevedor: [
                {
                    key: 'selecionar',
                },
                {
                    key: 'nome',
                    label: 'Nome Devedor'
                },
                {
                    key: 'cpfCnpj',
                    label: 'Documento Devedor'
                }
            ],
            selectedsDevedores: [],
            devedorModal: {
                numeroUnico: null,
                codDevedor: null,
                nome: null,
                cpfCnpj: null,
                cep: null
            },
            configTableDevedor: {
                perPage: 10,
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0,
                quantidadeGeral: 0,
                totalProcessos: 0,
                visible: false
            },
            devedorValidations: {
                nome: { valid: true, message: "" },
                cpfCnpj: { valid: true, message: "" }
            },
            devedorModalValidations: {
                nome: { valid: true, message: "" },
                cpfCnpj: { valid: true, message: "" }
            },
            exibirMensagemIntitutoAguaETerra: {
                valid: true,
                message: 'Dívida Ativa não SEFA! Clique em salvar APENAS se a dívida ativa informada acima for do Instituto Água e Terra!'
            },
            dataAjuizamentoValidation: {
                anoValido: {
                    valid: true,
                    message: 'Ano não pode ser inferior a 1900.'
                },
                campoObrigatorio: {
                    valid: true,
                    message: 'Campo obrigatório.'
                },
                formatoCorreto: {
                    valid: true,
                    message: 'Data deve estar no formato DD/MM/YYYY.'
                }
            },
            load: false,
            modalCdaModoIncluir: true,
            modalDevedorModoIncluir: true,
            dados: {
                municipios: [],
                ufs: [],

            },
            contribuinte: {
                nome: null,
                documento: null,
                telefone: null,
                email: null,
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                uf: null,
                municipio: null
            },
        }
    },
    computed: {
        getTheme() {
            return this.$store.getters.getTheme;
        }
    },
    methods: {
        editarDataAjuizamento() {
            this.configTableCda.load = true;
            this.selectedsDevedores = [],
                this.selectedsCdas = [],
                axios.post(`${this.urlApi}/v1/processosDigitalizados/atualizarDataAjuizamento/${this.processo.numeroUnico}`,
                    this.formDataEdicao.dataAjuizamento, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if (response.data != null) {
                        this.processo.numeroUnico = response.data.numeroUnico;
                        this.dataAjuizamentoOriginal = response.data.dataajuizamento;
                        this.processo.dataajuizamento = response.data.dataajuizamento;
                        this.processo.quantidadeDevedores = response.data.quantidadeDevedores;
                        this.processo.cdas = response.data.listCdaSefaProcessoMigradoVO;
                        this.processo.devedores = response.data.listaDevedorProcessoMigradoVO;
                        this.$refs['modal-editar-data-ajuizamento'].hide();
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTableCda.load = false;
                })
        },
        buscarProcesso(numeroUnico) {
            this.configTableCda.load = true;
            this.selectedsDevedores = [],
                this.selectedsCdas = [],
                axios.get(`${this.urlApi}/v1/processosDigitalizados/${numeroUnico}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if (response.data != null) {
                        this.processo.numeroUnico = response.data.processoMigradoVO.numeroUnico;
                        this.dataAjuizamentoOriginal = response.data.processoMigradoVO.dataajuizamento;
                        this.processo.dataajuizamento = response.data.processoMigradoVO.dataajuizamento;
                        this.processo.quantidadeDevedores = response.data.processoMigradoVO.quantidadeDevedores;
                        this.processo.cdas = response.data.processoMigradoVO.listCdaSefaProcessoMigradoVO;
                        this.processo.devedores = response.data.processoMigradoVO.listaDevedorProcessoMigradoVO;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTableCda.load = false;
                })
        },

        voltar() {
            this.$store.commit('setCnj', null);
            this.$router.push({ path: '/migracao' });
        },

        //TODO CDA
        toggleCheckCda(checked, cda) {
            if (checked) {
                this.selectedsCdas.push(cda);
            } else {
                const index = this.selectedsCdas.indexOf(cda);
                this.selectedsCdas.splice(index, 1);
                this.configTableCda.checkedAll = false;
            }
        },

        toggleAllCdas(checked) {
            if (checked) {
                this.processo.cdas.forEach(el => {
                    el.checked = true;
                    if (!this.selectedsCdas.includes(el)) {
                        this.selectedsCdas.push(el);
                    }
                })
            } else {
                this.processo.cdas.forEach(el => {
                    el.checked = false;
                    if (this.selectedsCdas.includes(el)) {
                        const index = this.selectedsCdas.indexOf(el);
                        this.selectedsCdas.splice(index, 1);
                    }
                })
            }
        },

        consultarCda() {
            //this.$refs.load.showLoading();
            validacoesUtil.limparValidacao(this.cdaModalValidations);
            validacoesUtil.validarCampoObrigatorio(this.cdaModal.numeroDivida, this.cdaModalValidations.numeroDivida);

            if (validacoesUtil.validadacaoContemErros(this.cdaModalValidations)) {
                return;
            }

            if (this.cdaModal.numeroDivida != '999999999') {
                axios.get(`${this.urlApi}/v1/processosDigitalizados/consultarDetalhesCda/${this.cdaModal.numeroDivida}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    let cdaResponse = response.data;
                    console.log(cdaResponse)
                    if (cdaResponse.msgErro == null) {
                        this.cdaModal.numeroDivida = cdaResponse.numeroDivida;
                        this.cdaModal.tipoCredito = cdaResponse.tipoCredito;
                        this.cdaModal.origem = cdaResponse.origem;
                        this.cdaModal.numeroUnico = this.processo.numeroUnico;
                        this.modalCdaModoIncluir = false;
                    } else if ('0002' == cdaResponse.codigoChamada && cdaResponse.msgErro == this.exibirMensagemIntitutoAguaETerra.message) {
                        this.cdaModal.tipoCredito = cdaResponse.tipoCredito;
                        this.cdaModal.origem = null;
                        this.cdaModal.numeroUnico = this.processo.numeroUnico;
                        this.modalCdaModoIncluir = false;
                        this.exibirMensagemIntitutoAguaETerra.valid = false;
                    } else if (cdaResponse.msgErro != null && cdaResponse.msgErro != '') {
                        validacoesUtil.adicionarErroDeValidacao(this.cdaModalValidations.numeroDivida, cdaResponse.msgErro);
                    } else {
                        validacoesUtil.adicionarErroDeValidacao(this.cdaModalValidations.numeroDivida, "Serviço temporariamente indisponível! Tente novamente mais tarde.");
                    }

                }).catch((error) => {
                    validacoesUtil.adicionarErroDeValidacao(this.cdaModalValidations.numeroDivida, "Serviço temporariamente indisponível! Tente novamente mais tarde.");
                }).finally(() => {
                    //this.$refs.loading.hideLoading();
                })
            } else {
                this.cdaModal.numeroUnico = this.processo.numeroUnico;
                this.modalCdaModoIncluir = false;
            }
        },

        adicionarCda() {
            //this.$refs.load.showLoading();
            validacoesUtil.limparValidacao(this.cdaModalValidations);
            validacoesUtil.validarCampoObrigatorio(this.cdaModal.numeroDivida, this.cdaModalValidations.numeroDivida);

            if (validacoesUtil.validadacaoContemErros(this.cdaModalValidations)) {
                return;
            }

            axios.post(`${this.urlApi}/v1/processosDigitalizados/salvarCda`, this.cdaModal, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                let cdaResponse = response.data;

                if (cdaResponse.msgErro == null) {
                    this.cdaModal.numeroDivida = cdaResponse.numeroDivida;
                    this.cdaModal.tipoCredito = cdaResponse.tipoCredito;
                    this.cdaModal.origem = cdaResponse.origem;
                    this.buscarProcesso(this.processo.numeroUnico);
                    this.$refs['modal-incluir-editar-cda'].hide();
                } else {
                    validacoesUtil.adicionarErroDeValidacao(this.cdaModalValidations.numeroDivida, cdaResponse.msgErro);
                }
            }).catch((error) => {
                this.exibirErro(error);
            }).finally(() => {
                //this.$refs.loading.hideLoading();
            })
        },

        excluirCdas() {
            if (this.selectedsCdas.length == this.processo.cdas.length) {
                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger', errors: ['O processo deve conter pelo menos uma CDA cadastrada!'] });
            } else {
                this.$store.commit("setMessages", null);

                let payload = {
                    'numeroUnico': this.processo.numeroUnico,
                    'listCdaSefaProcessoMigradoVO': this.selectedsCdas
                }
                axios.post(`${this.urlApi}/v1/processosDigitalizados/excluirCdas`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(() => {
                    this.buscarProcesso(this.processo.numeroUnico);
                }).catch((error) => {
                    this.exibirErro(error);
                }).finally(() => {
                    //this.$refs.loading.hideLoading();
                })
            }
        },

        abrirModalCdaModoInclusao() {
            validacoesUtil.limparValidacao(this.cdaModalValidations);
            this.alterarModalCdaParaModoInclusao();
            this.cdaModal = {
                codCdaSefa: null,
                numeroDivida: null,
                tipoCredito: null,
                origem: null
            },
                this.$refs['modal-incluir-editar-cda'].show();
        },

        abrirModalCdaModoEdicao() {
            validacoesUtil.limparValidacao(this.cdaModalValidations);
            this.alterarModalCdaParaModoEdicao();
            this.cdaModal = { ...this.selectedsCdas[0] };
            this.$refs['modal-incluir-editar-cda'].show();
        },

        abrirModalDataAjuizamentoEdicao() {
            this.formDataEdicao.dataAjuizamento = this.processo.dataajuizamento
            this.$refs['modal-editar-data-ajuizamento'].show();
        },

        alterarModalCdaParaModoEdicao() {
            this.modalCdaModoIncluir = false;
        },

        alterarModalCdaParaModoInclusao() {
            this.modalCdaModoIncluir = true;
            this.cdaModal.tipoCredito = null;
            this.cdaModal.origem = null;
            this.exibirMensagemIntitutoAguaETerra.valid = true;
        },

        //TODO Devedor
        toggleCheckDevedor(checked, devedor) {
            if (checked) {
                this.selectedsDevedores.push(devedor);
            } else {
                const index = this.selectedsDevedores.indexOf(devedor);
                this.selectedsDevedores.splice(index, 1);
                this.configTableDevedor.checkedAll = false;
            }
        },

        toggleAllDevedores(checked) {
            if (checked) {
                this.processo.devedores.forEach(el => {
                    el.checked = true;
                    if (!this.selectedsDevedores.includes(el)) {
                        this.selectedsDevedores.push(el);
                    }
                })
            } else {
                this.processo.devedores.forEach(el => {
                    el.checked = false;
                    if (this.selectedsDevedores.includes(el)) {
                        const index = this.selectedsDevedores.indexOf(el);
                        this.selectedsDevedores.splice(index, 1);
                    }
                })
            }
        },

        abrirModalDevedorModoInclusao() {
            validacoesUtil.limparValidacao(this.devedorModalValidations);
            this.alterarModalDevedorParaModoInclusao();
            this.devedorModal = {
                numeroUnico: null,
                codDevedor: null,
                nome: null,
                cpfCnpj: null,
                cep: null
            },
                this.$refs['modal-incluir-editar-devedor'].show();
        },

        abrirModalDevedorModoEdicao() {
            validacoesUtil.limparValidacao(this.devedorModalValidations);
            this.alterarModalDevedorParaModoEdicao();
            this.devedorModal = { ...this.selectedsDevedores[0] };
            this.$refs['modal-incluir-editar-devedor'].show();
        },

        alterarModalDevedorParaModoEdicao() {
            this.modaDevedorModoIncluir = false;
        },

        alterarModalDevedorParaModoInclusao() {
            this.modaDevedorModoIncluir = true;
        },

        salvarDevedor() {
            //this.$refs.load.showLoading();
            validacoesUtil.limparValidacao(this.devedorModalValidations);

            if (this.devedorModal.cpfCnpj != null
                && (this.devedorModal.cpfCnpj.length <= 14 && !this.validarCpf(this.devedorModal.cpfCnpj))
                || (this.devedorModal.cpfCnpj.length > 14 && !this.validarCNPJAlfanumerico(this.devedorModal.cpfCnpj))) {
                validacoesUtil.adicionarErroDeValidacao(this.devedorModalValidations.cpfCnpj, "Número Inválido!");
            }

            if (validacoesUtil.validadacaoContemErros(this.devedorModalValidations)) {
                return;
            }

            let payload = {
                ...this.devedorModal,
                'numeroUnico': this.processo.numeroUnico
            }

            if (this.devedorModal.codDevedor == null) {
                this.contribuinte = {
                    codDevedor: null,
                    nome: this.devedorModal.nome,
                    documento: this.devedorModal.cpfCnpj,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: null,
                    municipio: null
                }
                this.$refs['modal-incluir-dados-devedor'].show();
            } else {
                axios.post(`${this.urlApi}/v1/processosDigitalizados/salvarDevedor`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.buscarProcesso(this.processo.numeroUnico);
                    this.$refs['modal-incluir-editar-devedor'].hide();
                }).catch((error) => {
                    this.exibirErro(error);
                }).finally(() => {
                    //this.$refs.loading.hideLoading();
                })
            }
        },

        salvarDadosDevedor() {
            let payload = {
                ...this.contribuinte,
                'numeroUnico': this.processo.numeroUnico
            }

            axios.post(`${this.urlApi}/v1/processosDigitalizados/salvarDadosDevedor`, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(() => {
                this.buscarProcesso(this.processo.numeroUnico);
                this.$refs['modal-incluir-editar-devedor'].hide();
                this.$refs['modal-incluir-dados-devedor'].hide();
            }).catch((error) => {
                this.exibirErro(error);
            })
        },

        closeModal() {
            this.$refs['modal-incluir-editar-devedor'].hide();
            this.$refs['modal-incluir-dados-devedor'].hide();
        },

        excluirDevedor() {
            if (this.selectedsDevedores.length == this.processo.devedores.length) {
                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger', errors: ['O processo deve conter pelo menos um Devedor cadastrado!'] });
            } else {
                this.$store.commit("setMessages", null);

                let payload = {
                    'numeroUnico': this.processo.numeroUnico,
                    'listaDevedorProcessoMigradoVO': this.selectedsDevedores
                }
                axios.post(`${this.urlApi}/v1/processosDigitalizados/excluirDevedores`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(() => {
                    this.buscarProcesso(this.processo.numeroUnico);
                }).catch((error) => {
                    this.exibirErro(error);
                }).finally(() => {
                    //this.$refs.loading.hideLoading();
                })
            }
        },

        removeSpecialCharacters(value) {
            return value == null ? null : value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ ]/g, "");
        },

        removeSpecialCharactersGeral(value) {
            return value == null ? null : value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ1234567890@_\.\-()\[\] ]/g, "");
        },

        removeSpecialCharactersGeralVirgula(value) {
            return value == null ? null : value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ1234567890@_,\.\-()\[\] ]/g, "");
        },

        removeSpecialCharactersNumero(value) {
            return value == null ? null : value.replace(/[^abcdefghijklmnopqrstuvxwyzáàãéêíõóôúçABCDEFGHIJKLMNOPQRSTUVXWYZÁÀÃÉÊÍÕÓÔÚÇ1234567890 ]/g, "");
        },

        async listarUfs() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.get(`${urlApi}/v1/procurador/listarUfs`, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            }).then(response => {
                this.dados.ufs = response.data
            })
        },

        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listar/${this.contribuinte.uf.nome}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
                .then(response => {
                    this.dados.municipios = response.data
                })
        },

        obterEnderecoPorCep() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

			axios.get(`${urlApi}/neocep/enderecamento/v3/endereco/${cepNumeros}/${2}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
                .then(response => {
                    this.contribuinte.uf = null;
                    for (var i = 0; i < this.dados.ufs.length; i++) {
                        if (this.dados.ufs[i].sigla === response.data.uf.sigla) {
                            this.contribuinte.uf = this.dados.ufs[i];
                        }
                    }

                    this.listarMunicipios();

                    this.contribuinte.municipio = response.data.cidade;
                    this.contribuinte.logradouro = response.data.endereco;
                    this.contribuinte.bairro = response.data.bairro;
                    this.contribuinte.complemento = response.data.complemento;
                })
        },
    },
    watch: {
        'formDataEdicao.dataAjuizamento'(newValor) {
            this.dataAjuizamentoValidation.campoObrigatorio.valid = newValor ? true : false
            if (newValor.length === 10) {
                this.dataAjuizamentoValidation.formatoCorreto.valid = true
                const year = parseInt(newValor.slice(newValor.length - 4))
                this.dataAjuizamentoValidation.anoValido.valid = year < 1900 ? false : true
            } else {
                this.dataAjuizamentoValidation.formatoCorreto.valid = false
            }
        },
    },
    mounted() {
        this.$refs.wizard.nextTab();
        this.processo = {
            numeroUnico: null,
            quantidadeDevedores: null,
            cdas: [],
            devedores: []
        };

        this.$store.commit("setMessages", {});
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;
        if (this.$store.getters.getCnj != null) {
            this.buscarProcesso(this.$store.getters.getCnj.replace(/[^0-9]/g, ''));
        }

        this.listarUfs();
    },
}
</script>
